import { propertyUseQuery, propertyAlgoliaQueryFn } from 'Services/reactQuery'
import errorLogger from 'Root/errorLogger'
import { ALGOLIA_PREFIX } from 'Config/config'


export const fetchComparableArchivedListings = async ({ listing, offer, startDateUnix }) => {
  if(!listing) return Promise.resolve({ response: null })
  const { lat, lng } = listing.address
  const { mls_number: mlsNumber, asking_price: askingPrice,
    sqft, home_type: homeType, sqft_min: sqftMin, sqft_max: sqftMax,
    subtype, beds_full: bedsFull,
  } = listing

  let filters = ['(status:"Sold")']

  if(startDateUnix) {
    filters.push(`(end_date_unix >= ${startDateUnix})`)
  }
  if(offer) {
    filters.push(`(offer:"${offer}")`)
  }
  if(askingPrice) {
    filters.push(`(asking_price:${askingPrice * 0.85} TO ${askingPrice * 1.1})`)
  }
  if(homeType) {
    filters.push(`(home_type:"${homeType}")`)
  }
  if(subtype) {
    filters.push(`(sub_type:"${subtype}")`)
  }
  if(bedsFull) {
    filters.push(`(bedrooms:${bedsFull > 1 ? bedsFull - 1 : 0} TO ${bedsFull + 1})`)
  }
  if(sqft) {
    filters.push(`(sqft:${sqft * 0.85} TO ${sqft * 1.1})`)
  } else if(sqftMin && sqftMax) {
    filters.push(`(sqft_min: ${sqftMin * 0.85} TO ${sqftMin * 1.1})`)
    filters.push(`(sqft_max: ${sqftMax * 0.85} TO ${sqftMax * 1.1})`)
  }
  if(mlsNumber) {
    filters.push(` NOT objectID:"${mlsNumber}"`)
  }
  filters = filters.length > 1 ? filters.join(' AND ') : filters

  let radiusMeter = 1000
  let result = {
    nbHits: 0,
    hits: [],
  }
  try {
    while((result && result.nbHits < 10) && radiusMeter < 6000) {
      // eslint-disable-next-line
      result = await propertyAlgoliaQueryFn({
        query: [
          {
            indexName: ALGOLIA_PREFIX + 'search_archive_listings_end_date_unix_desc',
            params: {
              filters,
              hitsPerPage: 10,
              aroundLatLng: `${lat}, ${lng}`,
              aroundRadius: radiusMeter,
            },

          },
        ],
      })
      radiusMeter += 1000
    }
  } catch(e) {
    errorLogger('algoliaListingComparableArchived', e)
  }
  return Promise.resolve(result && result.nbHits ? { response: { data: { data: result.hits } } } : null)
}

export const useFetchComparableArchivedListings = ({ listing, offer, startDateUnix }) => (
  propertyUseQuery(
    ['comparableArchivedListings', listing?.id, offer, startDateUnix],
    () => fetchComparableArchivedListings({ listing, offer, startDateUnix }),
    { enabled: Boolean(listing && offer) })
)
